'use client'

import { Link } from '@/components/Link'
import Typography from '@/components/Typography/Typography'
import { toKebabCase } from '@/utils/string'
import { getLinkPathname } from '@/utils/urls'
import { showRepublishingHint } from '@/elements/widgets/Article/ArticleDetailHead'
import styles from './ArticleDetailFooter.module.scss'

type FooterWidgetContext = {
  readonly items: ReadonlyArray<{
    readonly id: string
    readonly model: FooterProps
  }>
}

type FooterProps = {
  readonly publishedAt: string
  readonly lastmodifiedAt: string
  readonly republishing: boolean
  readonly source?: string
  readonly 'source-default'?: boolean
  readonly tagpages?: Array<{
    readonly label: string
    readonly url: string
  }>
}

const Tags = ({ footerProps }: { footerProps: FooterProps }) => (
  <>
    {footerProps.tagpages && footerProps.tagpages.length > 0 && (
      <div className={styles.tags}>
        {footerProps.tagpages?.map((tag, index) => (
          <Link href={getLinkPathname(tag.url)} title={tag.label} key={toKebabCase(tag.label) + index}>
            <Typography as="span" variant="s" weight="bold">
              {tag.label}
            </Typography>
          </Link>
        ))}
      </div>
    )}
  </>
)

const Source = ({ footerProps }: { footerProps: FooterProps }) => {
  const source = footerProps.source
  const sourceNtv = footerProps['source-default']

  if (sourceNtv && source) {
    return <div className={styles.source}>{`Verwendete Quellen: ntv.de, ${footerProps.source}`}</div>
  } else if (sourceNtv && !source) {
    return <div className={styles.source}>Verwendete Quelle: ntv.de</div>
  } else if (source) {
    return <div className={styles.source}>{`Verwendete Quellen: ${source}`}</div>
  }

  return <></>
}

const RepublishingHint = ({ footerProps }: { footerProps: FooterProps }) => {
  if (showRepublishingHint(footerProps.republishing, footerProps.publishedAt, footerProps.lastmodifiedAt)) {
    const date = new Date(footerProps.publishedAt).toLocaleString('de-DE', {
      weekday: 'long',
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    })
    return (
      <Typography
        variant="m"
        className={styles.repub}
      >{`(Dieser Artikel wurde am ${date} erstmals veröffentlicht.)`}</Typography>
    )
  }
  return <></>
}

const ArticleDetailFooter = ({ item }: { item: FooterWidgetContext }) => {
  const footerProps: FooterProps = item.items?.[0]?.model
  return (
    <>
      {footerProps && (
        <>
          <Source footerProps={footerProps} />
          <Tags footerProps={footerProps} />
        </>
      )}
    </>
  )
}

export default ArticleDetailFooter
